import React from 'react';
import { find, cloneDeep, filter, map } from 'lodash';
import Popup from '../../Popup';
import PopOverMenu from '../../PopOverMenu';
import Img from '../../Img';
import styles from './addOrganizerPopUpNew.scss';

const _ = { find, cloneDeep, filter, map };

class AddOrganizerPopup extends React.Component {
    constructor(props) {
        super(props);
        const organizerTitle = ['Not part of this Event', 'Provider', 'Head Provider'];
        const organizers = this.props.organizers || [];
        const clubMembers = _.filter(this.props.clubMembers, (object) => { return (object.role === 'Owner' || object.role === 'Admin'); }) || [];
        clubMembers.forEach((clubMember) => {
            const organizer = _.find(organizers, { memberId: clubMember.memberId });
            clubMember.isSelected = !!organizer;
            clubMember.eventDirectorRole = organizer ? organizer.eventDirectorRole : 0;
        });
        this.state = {
            organizerTitle,
            clubMembers,
            error: null,
        };
    }

    render() {
        return (
            <Popup
                className={`popup-sm ${styles.popup}`}
                onCloseClick={this.props.closePopup}
                config={{
                    fullScreen: false,
                    noPadding: true,
                    topGradient: true,
                    style: { 'max-height': '530px' },
                }}
            >
                <div className="popup-section p24 pt0 pb0">
                    <h5>Add Event Providers</h5>
                    <p>Select which club providers will be displayed as an provider for this event for players to see:</p>
                </div>
                <div className="popup-section p24">
                    <div className={`${styles.adminsList}`}>
                        {this.state.clubMembers.map((clubMember, i) => {
                            if (clubMember.role !== 'FormerMember') {
                                const { clubMembers } = this.state;
                                return (
                                    <div
                                        className={`radio-button radio-button-xl noselect mb8`}
                                        key={`club-member-${i}`}
                                    >
                                        <div
                                            className={`${styles.checkBoxContainer} ${clubMember.isSelected ? styles.selected : ''}`}
                                            data-testid="event-edit.add-organizer.member-checkbox"
                                            onClick={() => {
                                                const clonedClubMembers = _.cloneDeep(clubMembers);
                                                const member = _.find(clonedClubMembers, { memberId: clubMember.memberId });

                                                if (member.eventDirectorRole === 2) {
                                                    this.setState({
                                                        error: 'Please select a new Head Provider before you deselect current one',
                                                    });
                                                    return;
                                                }

                                                member.isSelected = !member.isSelected;
                                                member.eventDirectorRole = member.isSelected ? 1 : 0;

                                                this.setState({
                                                    clubMembers: clonedClubMembers,
                                                    error: null,
                                                });
                                            }}
                                        >
                                            <div className={`row align-items-center`}>
                                                <div className={`col-sm-2`}>
                                                    <div className={`${styles.checkIcon}`}>
                                                        {clubMember.isSelected && (
                                                            <Img src="/img/check-mark.svg" />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className={`col-sm-8`}>
                                                    <div className="person-details">
                                                        <div
                                                            className={`${styles.longNames} text-medium text-dark`}
                                                            title={`${clubMember.firstName} ${clubMember.lastName}`}
                                                        > {clubMember.firstName} {clubMember.lastName}
                                                        </div>
                                                        <div className="text-small text-uppercase">
                                                            {this.state.organizerTitle[clubMember.eventDirectorRole]}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-sm-2`}>
                                                    {clubMember.eventDirectorRole !== 2 && (
                                                        <PopOverMenu
                                                            popOverMenuClass="float-right"
                                                            horizontalEllipsis={true}
                                                            menuItems={[
                                                                ...([{ value: '2', label: 'Make Head Provider' }]),
                                                            ]}
                                                            onSelected={() => {
                                                                const updatedClubMembers = _.map(clubMembers, (member) => {
                                                                    const updatedMember = member.memberId === clubMember.memberId
                                                                        ? ({ ...member, isSelected: true, eventDirectorRole: 2 })
                                                                        : (({ ...member, eventDirectorRole: member.eventDirectorRole === 2 ? 1 : member.eventDirectorRole }));

                                                                    return updatedMember;
                                                                });
                                                                this.setState({
                                                                    clubMembers: updatedClubMembers,
                                                                    error: null,
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                    {this.state.error && (
                        <div className={`${styles.error}`}>{this.state.error}</div>
                    )}
                    <div className={`row mt24`}>
                        <div className={`col-md-6`}>
                            <button
                                type="button"
                                className={`btn btn-default btn-sm text-uppercase btn-block`}
                                data-testid="event-edit.cancel-organizer-btn"
                                onClick={this.props.closePopup}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className={`col-md-6`}>
                            <button
                                type="button"
                                className={`btn btn-primary btn-sm text-uppercase btn-block`}
                                data-testid="event-edit.confirm-organizers-btn"
                                onClick={() => {
                                    if (_.filter(this.state.clubMembers, (object) => { return object.isSelected; }).length > 0) {
                                        this.props.confirmPopup(this.state.clubMembers);
                                    } else {
                                        this.setState({
                                            error: 'You need to select at least 1 event provider',
                                        });
                                    }
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

export default AddOrganizerPopup;
